import dayjs from "dayjs";
import { Notification } from "../../hooks/react-query/dispatch/useNotifications";
import { mockDispatchStops } from "./stops.mock";
import { mockDispatchRoutes } from "./routes.mock";

const stop = mockDispatchStops.default[0];
const route = mockDispatchRoutes.default.find((r) => r.id === stop.routeId);
const driver = route?.driver;
const shipment = stop.pickups[0];

export const mockNotifications = {
  default: [
    {
      id: 1,
      createdAt: dayjs().hour(15).minute(0).second(0),
      driverId: driver?.id ?? null,
      driverName: driver?.name ?? null,
      driverProfilePicture: driver?.profilePicture ?? null,
      routeName: route?.name ?? null,
      shipmentId: shipment.id,
      stopName: stop.name,
      message: "missed their 35-min break.",
      isRead: false,
      routeId: route?.id ?? null,
      stopId: stop.id,
      type: "DriverLunchRequired",
    },
    {
      id: 2,
      createdAt: dayjs().subtract(30, "minutes"),
      driverId: driver?.id ?? null,
      driverName: driver?.name ?? null,
      driverProfilePicture: driver?.profilePicture ?? null,
      message: "is approaching 2 hours on duty",
      isRead: false,
      routeId: route?.id ?? null,
      stopId: stop.id,
      type: "DriverOnDutyTimeout",
      routeName: route?.name ?? null,
      shipmentId: shipment.id,
      stopName: stop.name,
    },
    {
      id: 3,
      createdAt: dayjs().subtract(60, "minutes"),
      driverId: driver?.id ?? null,
      driverName: driver?.name ?? null,
      driverProfilePicture: driver?.profilePicture ?? null,
      stopName: stop.name,
      message: "didn't complete",
      isRead: true,
      routeId: route?.id ?? null,
      stopId: stop.id,
      type: "DriverDidntCompleteStop",
      routeName: route?.name ?? null,
      shipmentId: shipment.id,
    },
    {
      id: 4,
      createdAt: dayjs().subtract(45, "minutes"),
      driverId: driver?.id ?? null,
      driverName: driver?.name ?? null,
      driverProfilePicture: driver?.profilePicture ?? null,
      stopName: stop.name,
      message: "rescheduled",
      isRead: true,
      routeId: route?.id ?? null,
      stopId: stop.id,
      type: "DriverRescheduledStop",
      routeName: route?.name ?? null,
      shipmentId: shipment.id,
    },
  ],
  empty: [],
} as const satisfies Record<string, Notification[]>;
